var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4922 2.31305V8.69305C11.4922 9.99972 10.0722 10.8197 8.93885 10.1664L6.17219 8.57305L3.40552 6.97305C2.27219 6.31972 2.27219 4.68638 3.40552 4.03305L6.17219 2.43305L8.93885 0.839714C10.0722 0.18638 11.4922 0.999713 11.4922 2.31305ZM0.508186 10.1197C0.781519 10.1197 1.00819 9.89305 1.00819 9.61972V1.37971C1.00819 1.10638 0.781519 0.879714 0.508186 0.879714C0.234853 0.879714 0.00818634 1.10638 0.00818634 1.37971V9.61972C0.00818634 9.89305 0.228186 10.1197 0.508186 10.1197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.af5b5cbcc432c1750830678595248373.svg";
export { ForwardRef as ReactComponent };